import React from 'react'
import { SvgIconProps } from './Home'

const SvgStoreIcon = ({ fill, width, height, stroke }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width ?? '18'}
    height={height ?? '18'}
    viewBox={`0 0 18 18`}
    fill="none"
  >
    <path
      fill={fill ?? '#353535'}
      d="M18 6.158c0-.19 0-.284-.095-.474l-1.61-5.02A1.165 1.165 0 0015.253 0H2.747c-.473 0-.852.284-.947.758L.095 5.874C0 5.968 0 6.064 0 6.253v.19c0 1.041.379 1.989 1.137 2.746v7.769c0 .568.474 1.042 1.042 1.042H15.82c.569 0 1.042-.474 1.042-1.042V9.189A3.794 3.794 0 0018 6.442v-.095-.19zm-7.768 6.726v3.032H7.768v-3.032h2.464zm-7.01-2.652c.189 0 .473.094.662.094.948 0 1.895-.379 2.558-.947.663.663 1.61.947 2.558.947.947 0 1.895-.379 2.558-.947.663.663 1.61.947 2.558.947.19 0 .473 0 .663-.094v5.684h-2.463v-4.074c0-.568-.474-1.042-1.042-1.042H6.726c-.568 0-1.042.474-1.042 1.042v4.074H3.221v-5.684zm10.894-1.99c-.663 0-1.326-.379-1.61-1.042a1.042 1.042 0 00-.948-.568c-.38 0-.758.189-.947.568-.285.663-.948 1.042-1.611 1.042S7.674 7.863 7.39 7.2a1.042 1.042 0 00-.948-.568c-.379 0-.758.189-.947.568-.284.663-.948 1.042-1.61 1.042-.38 0-.759-.095-1.043-.379-.474-.284-.758-.852-.758-1.42v-.19l1.421-4.169h10.99l1.42 4.169v.189c0 .569-.283 1.137-.757 1.421-.284.284-.663.38-1.042.38z"
    ></path>
  </svg>
)

export default SvgStoreIcon
